var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopperConv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.003,
    height: 20.001,
    viewBox: "0 0 15.003 20.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42063",
    "data-name": "Group 42063",
    transform: "translate(-63.969 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "object_4_",
    transform: "translate(63.969 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42061",
    "data-name": "Group 42061"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_181052",
    "data-name": "Path 181052",
    d: "M76.61,5h-.9V4.223a4.222,4.222,0,1,0-8.444,0V5h-.939A2.365,2.365,0,0,0,63.969,7.36v7.951A4.7,4.7,0,0,0,68.659,20h5.623a4.7,4.7,0,0,0,4.69-4.69V7.36A2.365,2.365,0,0,0,76.61,5Zm-7.96-.775a2.843,2.843,0,0,1,5.686,0V5H68.65Zm8.944,11.088a3.315,3.315,0,0,1-3.311,3.311H68.659a3.315,3.315,0,0,1-3.311-3.311V7.36a.985.985,0,0,1,.984-.984H76.61a.985.985,0,0,1,.984.984Z",
    transform: "translate(-63.969 0)",
    fill: "#bebebe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42062",
    "data-name": "Group 42062",
    transform: "translate(3.302 7.518)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_181053",
    "data-name": "Path 181053",
    d: "M156.251,192.465a.689.689,0,0,0-.689.689v1.464a2.843,2.843,0,0,1-5.686,0v-1.464a.689.689,0,0,0-1.379,0v1.464a4.222,4.222,0,0,0,8.444,0v-1.464A.69.69,0,0,0,156.251,192.465Z",
    transform: "translate(-148.496 -192.465)",
    fill: "#bebebe"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopperConv);
export default __webpack_public_path__ + "static/media/ShopperConv.66fb25b93d23717e9a9982a2f05b9565.svg";
export { ForwardRef as ReactComponent };